import { motion } from "framer-motion";

const SRC = { happy: "/mascot-happy.png", wave: "/mascot-wave.png", read: "/mascot-read.png" };

export const Mascot = ({ pose = "happy", className = "w-24", float = true }) => (
  <img src={SRC[pose]} alt="Baby Monster, maskot windiku" className={`${className} select-none ${float ? "floaty" : ""}`} draggable={false} />
);

export const MascotBubble = ({ pose = "happy", children, testid }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    className="flex items-end gap-3"
    data-testid={testid}
  >
    <Mascot pose={pose} className="w-16 sm:w-20 shrink-0" />
    <div className="relative bg-white border border-pink-100 rounded-3xl rounded-bl-md px-4 py-3 text-sm text-gray-600 shadow-sm">
      {children}
    </div>
  </motion.div>
);
